// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Manufacturer } from './manufacturer';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ManufacturerCryptonym extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  guid!: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** DateTime */
  expirationDate?: Date;
  /** Int32 FK manufacturer */
  manufacturerId!: number;
  /** FK manufacturerId */
  manufacturer!: Manufacturer;
}

